module.exports = __webpack_public_path__ + "static/media/35-3.636e1e03.mp3";